import Cookies from 'universal-cookie';
import { pushToDataLayer } from '../../../services/gtmService';
import { MAXIMUM_COOKIE_AGE } from '../../constants';

type TrackBucketingParams = {
  cookieName: string;
  event: string;
  experimentKey: string;
  variationKey: string;
};

const trackBucketing = ({
  cookieName,
  event,
  experimentKey,
  variationKey,
}: TrackBucketingParams) => {
  const cookies = new Cookies();

  if (cookies.get(cookieName)) return;

  cookies.set(cookieName, 'true', {
    path: '/',
    maxAge: MAXIMUM_COOKIE_AGE,
  });

  pushToDataLayer({
    event,
    experimentKey,
    variationKey,
  });
};

export { trackBucketing };
